import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Tooltip } from "components";
import ExclamationCircleIcon from "assets/icons/ExclamationCircle";
import useThemeStore from "(store)/themeStore";

const TextArea = ({
  name,
  label,
  size = "small",
  placeholder,
  tooltipValue,
  isRequired = false,
  disabled = false,
}) => {
  const theme = useThemeStore((state) => state.theme);
  const isThemeDark = theme === "dark";
  const { errors, touched, setFieldValue } = useFormikContext();
  const showError = errors[name] && touched[name];

  const handleTextChange = (e) => {
    const newValue = e.target.value;
    setFieldValue(name, newValue);
  };

  return (
    <div className="form-control w-full">
      {label && (
        <div className="flex items-center gap-1 mb-1">
          <span className="flex gap-1 items-end">
            <span className="label-text dark:text-white">{label}</span>
            {isRequired && (
              <span className="text-red-500 font-extrabold">*</span>
            )}
          </span>
          {tooltipValue && (
            <Tooltip
              children={<ExclamationCircleIcon color={"red"} />}
              message={tooltipValue}
            />
          )}
        </div>
      )}
      <Field
        as="textarea"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        rows={5}
        onChange={handleTextChange}
        className={`flex w-full px-3 ${
          size === "large" ? "py-3" : "py-2"
        } border border-gray-300 placeholder-gray-500 rounded-lg focus:outline-none 
        ${
          isThemeDark
            ? "bg-slate-950 focus-within:bg-white focus-within:text-black text-gray-300"
            : "bg-white"
        }
        ${
          showError
            ? "focus-within:border-red-500 border-red-500"
            : `${
                isThemeDark
                  ? "dark:focus-within:border-[#FAB54E]"
                  : "focus-within:border-[#1996A6]"
              }`
        } 
        focus:z-10 sm:text-sm resize-none ${
          disabled
            ? `bg-gray-100 ${
                isThemeDark ? "bg-gray-800" : ""
              } cursor-not-allowed text-slate-400 placeholder:text-slate-400 `
            : ""
        }`}
      />
      {showError && (
        <ErrorMessage
          className="text-xs text-red-500 mt-1"
          name={name}
          component="div"
        />
      )}
    </div>
  );
};

export default TextArea;
